import { userStore } from "../../../store/user-store.ts";
import { t } from "../../../translations/t.ts";
import { cn } from "../../../ui/cn.ts";

function LoadingPlaceholder() {
  return (
    <div className="animate-pulse">
      <span className="text-2xl font-bold leading-none">-</span>
    </div>
  );
}

type Props = {
  isLoading: boolean;
  newCardsCount: number;
  repeatCardsCount: number;
  totalCardsCount: number;
};

export function CardReviewStats(props: Props) {
  const { isLoading, newCardsCount, repeatCardsCount, totalCardsCount } = props;

  return (
    <div
      className={cn("flex justify-between gap-2.5 -mb-0.5", {
        "flex-reverse": userStore.isRtl,
      })}
    >
      <div className="flex-1 px-1 bg-amber-100 text-amber-800 rounded-lg py-2 flex flex-col items-center border border-amber-50/50">
        {isLoading ? (
          <LoadingPlaceholder />
        ) : (
          <span className="text-2xl font-bold leading-none">
            {repeatCardsCount}
          </span>
        )}
        <span className="text-xs mt-1 opacity-80 text-center">
          {t("cards_to_repeat")}
        </span>
      </div>

      <div className="flex-1 px-1 bg-green-100 text-green-800 rounded-lg py-2 flex flex-col items-center border border-green-50/50">
        {isLoading ? (
          <LoadingPlaceholder />
        ) : (
          <span className="text-2xl font-bold leading-none">
            {newCardsCount}
          </span>
        )}
        <span className="text-xs mt-1 opacity-80 text-center">
          {t("cards_new")}
        </span>
      </div>

      <div className="flex-1 px-1 bg-secondary-bg text-text rounded-lg py-2 flex flex-col items-center border border-hint/10">
        {isLoading ? (
          <LoadingPlaceholder />
        ) : (
          <span className="text-2xl font-bold leading-none">
            {totalCardsCount}
          </span>
        )}
        <span className="text-xs mt-1 opacity-80 text-center">
          {t("cards_total")}
        </span>
      </div>
    </div>
  );
}
